import React, { useState } from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useJobPostings } from "@/hooks/useJobPostings"
// Assessment falloff is now integrated into ConversionTab
import { DateFilter } from "@/types/filters"

import MetricsFilter from "./MetricsFilter"
import ConversionTab from "./tabs/ConversionTab"
import CostsTab from "./tabs/CostsTab"
import KPIsTab from "./tabs/KPIsTab"
import OverviewTab from "./tabs/OverviewTab"
import PreferencesTab from "./tabs/PreferencesTab"
import TimeMetricsTab from "./tabs/TimeMetricsTab"

const MetricsContent: React.FC = () => {
  const [dateFilter, setDateFilter] = useState<DateFilter>({})
  const [metricType, setMetricType] = useState("overview")
  const [jobId, setJobId] = useState<string>("all")
  const { jobPostings, isLoadingJobPostings: _isLoadingJobPostings } = useJobPostings()

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">Recruitment Metrics Dashboard</h2>
        <div className="flex items-center gap-3">
          <MetricsFilter dateFilter={dateFilter} setDateFilter={setDateFilter} />
          <Select value={jobId} onValueChange={(v) => setJobId(v)}>
            <SelectTrigger className="w-[220px]">
              <SelectValue placeholder="All jobs" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All jobs</SelectItem>
              {Array.isArray(jobPostings) &&
                jobPostings.map((job) => (
                  <SelectItem key={job.id} value={String(job.id)}>
                    {job.title ?? job.id}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <Tabs value={metricType} onValueChange={setMetricType} className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="conversion">Conversion & Dropoff</TabsTrigger>
          <TabsTrigger value="time">Time Metrics</TabsTrigger>
          <TabsTrigger value="kpis">KPIs</TabsTrigger>
          <TabsTrigger value="preferences">Driver Preferences</TabsTrigger>
          {/* Not implemented yet */}
          <TabsTrigger value="costs">Cost Tracking</TabsTrigger>
        </TabsList>

        <TabsContent value="overview">
          <OverviewTab dateFilter={dateFilter} jobId={jobId === "all" ? undefined : jobId} />
        </TabsContent>

        <TabsContent value="conversion">
          <ConversionTab dateFilter={dateFilter} jobId={jobId === "all" ? undefined : jobId} />
        </TabsContent>

        <TabsContent value="time">
          <TimeMetricsTab dateFilter={dateFilter} jobId={jobId === "all" ? undefined : jobId} />
        </TabsContent>

        <TabsContent value="kpis">
          <KPIsTab dateFilter={dateFilter} jobId={jobId === "all" ? undefined : jobId} />
        </TabsContent>

        <TabsContent value="preferences">
          <PreferencesTab dateFilter={dateFilter} jobId={jobId === "all" ? undefined : jobId} />
        </TabsContent>

        <TabsContent value="costs">
          <CostsTab dateFilter={dateFilter} jobId={jobId === "all" ? undefined : jobId} />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default MetricsContent
